import { FormSection } from "../../../../../components/propertyDescription/descriptionUi";
import { ACCOMMODATION_OPTIONS } from "../constants";
import PropertyAccommodation from "../PropertyAccommodation";

type Props = {
  rooms?: number;
  suites?: number;
  bathrooms?: number;
  garages?: number;
  onChange: (field: string, value: unknown) => void;
};

export default function AccommodationsSection({
  rooms,
  suites,
  bathrooms,
  garages,
  onChange,
}: Props) {
  const values: Record<string, number | undefined> = {
    rooms,
    suites,
    bathrooms,
    garages,
  };

  return (
    <FormSection
      title="Acomodações"
      description="Quartos, suítes, banheiros e vagas do imóvel."
    >
      <div className="grid grid-cols-2 gap-x-4 gap-y-4 md:grid-cols-4">
        {ACCOMMODATION_OPTIONS.map((accommodation) => (
          <PropertyAccommodation
            key={accommodation.attributeName}
            label={accommodation.label}
            options={accommodation.options}
            value={values[accommodation.attributeName]}
            onChange={(option) =>
              onChange(accommodation.attributeName, option?.value)
            }
          />
        ))}
      </div>
    </FormSection>
  );
}
